import React, { useContext, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

import { selectDocumentProspectingPage } from '../../store/processDocument/documentProspecting'
import { useAppSelector } from '../../store/hooks'

import { DocumentProspectingPageType } from '../../models/DocumentProspecting'

import { useZocksQuota } from '../../components/ScopedBlock/hooks'
import { useDocumentTitle } from '../../common/useDocumentTitle'

import { DELTA_TRIAL_FEATURES } from '../Plan/DeltaTrial/DeltaTrialFeatures'
import { HeaderContext } from '../LayoutWithLeftSidebar/HeaderContext'
import { Upsell } from '../Plan/DeltaTrial/Upsell/Upsell'

import { DocumentProspectingInitialization } from './Initialization/DocumentProspectingInitialization'
import { DocumentProspectingFileUpload } from './DocumentProspecting/DocumentProspectingFileUpload'
import { DocumentProspectingHeader } from './DocumentProspecting/DocumentProspectingHeader'
import { DocumentProspecting } from './DocumentProspecting/DocumentProspecting'

export const DocumentProspectingPage = () => {
  useDocumentTitle('Document')

  const { isFetching: quotasFetching, hasQuota, quotaSuccess } = useZocksQuota()

  const { portalRef } = useContext(HeaderContext)

  const [headerContainer, setHeaderContainer] = useState<HTMLElement | null>(null)

  useEffect(() => {
    if (portalRef && portalRef.current) {
      setHeaderContainer(portalRef.current)
    }
  }, [portalRef])

  if (!quotaSuccess && quotasFetching) {
    return null
  }

  const documentProcessingEnabled = hasQuota('ai.documentSummaryAgent.value')

  return (
    <>
      {headerContainer ? createPortal(<DocumentProspectingHeader />, headerContainer) : null}
      {!documentProcessingEnabled ? (
        <Upsell feature={DELTA_TRIAL_FEATURES['processDocument']} />
      ) : (
        <div className='full-size-content'>
          <DocumentProspectingInitialization />
          <div className='h-100 w-100'>
            <DocumentProspectingPageContent />
          </div>
        </div>
      )}
    </>
  )
}

const DocumentProspectingPageContent = () => {
  const page = useAppSelector(selectDocumentProspectingPage)

  if (page === DocumentProspectingPageType.PROSPECTING_FILE_UPLOAD) {
    return <DocumentProspectingFileUpload />
  }

  if (page === DocumentProspectingPageType.PROSPECTING_STEPS) {
    return <DocumentProspecting />
  }

  return null
}
